import { render, staticRenderFns } from "./awbShipmentlist.vue?vue&type=template&id=e99c652a"
import script from "./awbShipmentlist.vue?vue&type=script&lang=js"
export * from "./awbShipmentlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports